class PrintInvoices {
    constructor(Alert, $http) {
        this.key = 'print-invoices';
        this.title = 'Print Invoices';
        this.level = 'selected';
        this.alert = Alert;
        this.api = $http;
    }

    action({}, store) {
        this.api.post('billing/invoices/print', {
            invoices: store.getters.selectedFilters,
        }).then(() => {
            store.dispatch('getData');
            this.alert.success('Print started', 'The messages are getting printed now');
        }, err => this.alert.handle(err))
    }
}

angular
    .module('festzelt-os.billing.invoices')
    .factory('printInvoices', [
        'Alert',
        '$http',
        (Alert, $http) => new PrintInvoices(Alert, $http)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/workflows/print-invoices.js